<template>
    <MainContent
        title="Listado de frecuencias para los pagos a plazos"
        v-model="filters"
        :meta="meta"
    >
        <!-- Skeleton: card superior (solo primera carga) -->
        <template v-if="!hasLoadedOnce && loading">
            <Card custom-classes="tw:mb-6">
                <Skeleton padding="tw:p-0" variant="tw:bg-transparent" customClass="tw:w-full">
                    <template #skeleton>
                        <div class="tw:space-y-4">
                            <div class="tw:flex tw:justify-end">
                                <SkeletonItem height="tw:h-9" customClass="tw:w-36 tw:rounded-lg" />
                            </div>
                            <div class="tw:border-t tw:border-gray-100 tw:pt-4">
                                <SkeletonItem height="tw:h-4" customClass="tw:w-3/4 tw:rounded" />
                            </div>
                        </div>
                    </template>
                </Skeleton>
            </Card>
        </template>

        <!-- Card real -->
        <template v-else>
            <Card custom-classes="tw:mb-6">
                <div>
                    <Button @click="onShowCreateModal">
                        Nueva frecuencia
                    </Button>
                </div>
                <div class="tw:mt-4 tw:pt-4 tw:border-t tw:border-gray-100">
                    <p class="tw:text-sm tw:text-gray-600">
                        *En este apartado es donde vamos a crear las frecuencias con las que se cobrará el importe, en caso de activar el pago a plazos en la categoría
                    </p>
                </div>
            </Card>
        </template>

        <FrecuenciaList
            :frecuencias="frecuencias.data"
            :loading="loading"
            @delete="borrar"
            @edit-save="handleEditSave"
        />

        <!-- Skeleton footer (solo primera carga) -->
        <template v-if="!hasLoadedOnce && loading">
            <Card :custom-classes="'tw:flex tw:flex-col tw:items-center tw:justify-between tw:gap-2 tw:pl-4 tw:pr-4 tw:py-2 tw:mt-6'">
                <Skeleton padding="tw:p-0" variant="tw:bg-transparent" customClass="tw:w-full">
                    <template #skeleton>
                        <div class="tw:flex tw:flex-col tw:w-full tw:md:flex-row tw:md:items-center tw:md:justify-between">
                            <div class="tw:flex tw:justify-between tw:items-center tw:gap-3">
                                <SkeletonItem height="tw:h-4" customClass="tw:w-18 tw:rounded tw:md:tw:hidden" />
                                <SkeletonItem height="tw:h-9" customClass="tw:w-20 tw:rounded-lg" />
                            </div>
                            <div class="tw:hidden tw:md:block">
                                <SkeletonItem height="tw:h-4" customClass="tw:w-48 tw:rounded tw:mx-auto" />
                            </div>
                            <div class="tw:flex tw:justify-center tw:items-center tw:gap-1">
                                <SkeletonItem v-for="n in 3" :key="'pag-sk-' + n" height="tw:h-8" customClass="tw:w-8 tw:rounded" />
                            </div>
                        </div>
                    </template>
                </Skeleton>
            </Card>
        </template>

        <!-- Create Modal (always in DOM, shown via $modal) -->
        <FrecuenciaEditModal
            name="create-frecuencia"
            :model-value="{ cantidad: null, frecuencia: '' }"
            :loading="creating"
            @save="handleCreate($event)"
            @close="onCloseCreateModal"
        />
    </MainContent>
</template>

<script setup>
    import { ref, watch, getCurrentInstance } from 'vue'
    import { useFrecuenciasIndex } from '@/composables/admin/bases/useFrecuenciasIndex'
    import MainContent from '@/modules/admin/ui/MainContent.vue'
    import Button from '@/modules/admin/ui/Button.vue'
    import Card from '@/modules/admin/ui/Card.vue'
    import FrecuenciaList from '../components/FrecuenciaList.vue'
    import FrecuenciaEditModal from '../components/FrecuenciaEditModal.vue'
    import { Skeleton, SkeletonItem } from '@/modules/admin/ui/skeleton'

    const { proxy } = getCurrentInstance()
    const creating = ref(false)

    const {
        frecuencias, loading, filters, meta, fetch, borrar, crear, editar, closeCreateModal
    } = useFrecuenciasIndex()

    const hasLoadedOnce = ref(false)
    watch(frecuencias, val => {
        if (val?.data?.length) hasLoadedOnce.value = true
    })

    function onShowCreateModal() {
        proxy?.$modal?.show('create-frecuencia')
    }

    function onCloseCreateModal() {
        proxy?.$modal?.hide('create-frecuencia')
        closeCreateModal()
    }

    async function handleCreate(formData) {
        creating.value = true
        await crear(formData)
        proxy?.$modal?.hide('create-frecuencia')
        creating.value = false
    }

    async function handleEditSave(formData) {
        await editar(formData)
    }
</script>
